<template>
    <div v-if="themeStore.themeIndex === 3">
        <GameSerchPageThree />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <GameSerchPageFour />
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import { useThemeStore } from '@/stores/theme';
import GameSerchPageThree from '@/themes/themeThree/home/gameSerchPage.vue';
import GameSerchPageFour from '@/themes/themeFour/home/gameSerchPage.vue';

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const themeStore = useThemeStore()

const isLoading = ref(false)


const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

</script>
<style scoped></style>